import { styled, keyframes } from 'styled-components';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const CircularProgress = styled.div`
  border: 4px solid #ccc;
  border-top: 4px solid rgba(0, 0, 0, 0);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${rotate} 1s linear infinite;
`;

export default CircularProgress;
